import React from 'react'
import FontAwesome from 'react-fontawesome'
import '../layouts/fontawesome/font-awesome-4.7.0/css/font-awesome.css'
import styles from './Quelle.module.css'

/*

<a>
      <FontAwesome name="facebook" title="Auf Facebook teilen" />
    </a>
    <a>
      <FontAwesome name="twitter" title="Auf Twitter teilen" />
    </a>
    <a>
      <FontAwesome name="google-plus" title="Auf Google+ teilen" />
    </a>
    <a>
      <FontAwesome name="envelope-o" title="Per Mail versenden" />
    </a>
    <FontAwesome name="print" title="Drucken" />
    <FontAwesome name="bookmark-o" title="Zu Merkzettel hinzufügen" />

/* FACEBOOK, TWITTER, GOOGLE

      href="http://www.facebook.com/sharer/sharer.php?u=https://www.arbeiterkammer.at/ueberuns/kontakt/index.html"
      target="_blank"


      href={
        'https://twitter.com/intent/tweet?url=' +
        props.location +
        '&via=Arbeiterkammer'
      }
      target="_blank"


      href="http://plus.google.com/share?url=https://www.arbeiterkammer.at/ueberuns/kontakt/index.html"
      target="_blank"


/* Mail

 href="mailto:?subject=Schon%20gelesen%3F&amp;body=Hier erreichen Sie uns. %0A%0Ahttps://www.arbeiterkammer.at/ueberuns/kontakt/index.html"
      
/* DRUCKEN 

onClick={() => window.print()} />

*/

/* BOOKMARK
onClick={() => {
        if (window.sidebar && window.sidebar.addPanel) {
          // Mozilla Firefox Bookmark
          window.sidebar.addPanel(document.title, window.location.href, '')
        } else if (window.external && 'AddFavorite' in window.external) {
          // IE Favorite
          window.external.AddFavorite(location.href, document.title)
        } else if (window.opera && window.print) {
          // Opera Hotlist
          this.title = document.title
          return true
        } else {
          // webkit - safari/chrome
          alert(
            'Press ' +
              (navigator.userAgent.toLowerCase().indexOf('mac') != -1
                ? 'Command/Cmd'
                : 'CTRL') +
              ' + D to bookmark this page.'
          )
        }
      }}
*/

export default props => (
  <div className={styles.quelle}>
    {/* {typeof Blob !== 'undefined' &&
      document && (
        <FontAwesome
          name="download"
          title="Karte als SVG herunteladen"
          onClick={() => {
            {
              const maps = document.querySelectorAll('svg.zoomMap')

              maps.forEach(element => {
                const blob = new Blob([element.outerHTML], {
                  type: 'image/svg+xml;charset=utf-8',
                })

                const link = document.createElement('a')
                link.href = URL.createObjectURL(blob)
                link.download = `${document.location.pathname
                  .replace(/\//g, '_')
                  .substr(1)}.svg`

                const click = new MouseEvent('click')
                link.dispatchEvent(click)
                URL.revokeObjectURL(link.href)
              })
            }
          }}/>
      )} */}
    <div className={styles.text}>{props.children}</div>
  </div>
)



// WEBPACK FOOTER //
// ./src/components/Quelle.js